module.exports = __webpack_public_path__ + "assets/img/9.73d3f098.jpg";